import { render, staticRenderFns } from "./Pedido.vue?vue&type=template&id=396a2050&scoped=true"
import script from "./Pedido.vue?vue&type=script&lang=js"
export * from "./Pedido.vue?vue&type=script&lang=js"
import style0 from "./Pedido.vue?vue&type=style&index=0&id=396a2050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a2050",
  null
  
)

export default component.exports